import { createTheme } from '@mui/material/styles';
import { CommonThemeOptions } from './commonTheme';
import type { IThemeOptions } from './index';

export const Scan2NotesOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Scan2Notes',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: '#AB57C7',
          '&.Mui-disabled': {
            color: '#743788',
          },
        },
        outlinedPrimary: {
          color: '#AB57C7',
          '&.Mui-disabled': {
            color: '#743788',
            border: '1px solid #743788',
          },
        },
        containedPrimary: {
          backgroundColor: '#AB57C7',
          '&.Mui-disabled': {
            backgroundColor: '#743788',
            color: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#fff',
          backgroundColor: '#AB57C7',
          background: '#AB57C7', // transcribe button
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#AB57C7',
      light: '#d372f3',
      dark: '#743788',
      contrastText: '#fff',
    },
  },
};

export const Scan2NotesTheme = createTheme(Scan2NotesOptions);
